import React from 'react';

export const Redirect = () => <></>;

export default Redirect;
